'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Queue = require('./Queue');

var _Queue2 = _interopRequireDefault(_Queue);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Abstract base class for other appenders.
 */
var BaseAppender = function () {
	function BaseAppender(config) {
		var _this = this;

		_classCallCheck(this, BaseAppender);

		this.queue = new _Queue2.default(config);
		this.queue.setDrainCallback(function (events) {
			if ((0, _helpers.isFunction)(_this.doAppend)) {
				events.forEach(function (event) {
					return _this.doAppend(event);
				});
			}

			if ((0, _helpers.isFunction)(_this.append)) {
				_this.append(events);
			}
		});

		_extends(this, {}, config);
	}

	/**
  * @param {array} events
     */


	_createClass(BaseAppender, [{
		key: 'append',
		value: function append(events) {}

		/**
   * Event handler for log events
      */

	}, {
		key: 'onLogEventHandler',
		value: function onLogEventHandler(message, payload) {
			this.queue.addToQueue(payload);
		}
	}]);

	return BaseAppender;
}();

exports.default = BaseAppender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/BaseAppender.js
// module id = 761
// module chunks = 0